import {
  Alert,
  Box,
  Button,
  Chip,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { Link } from "react-router-dom";
import { useIdentidade } from "../../api/ESocialJTServiceApi";
import {
  competenciaExibicao,
  cpfExibicao,
  dataExibicao,
  demonstrativos,
  informacoesRelevantes,
  numero,
  pagamentos
} from "../../shared/apresentacaoEvento";
import JsonPanel from "../json-panel/JsonPanel";
import { Abas, Campo, Indicadores } from "./Elementos";
import Demonstrativos from "./Demonstrativos";
import Totalizadores from "./Totalizadores";

import AutoriaRecebimento from "./AutoriaRecebimento";

export default function DetalhesEvento({ ocorrencia: o }) {
  const identidade = useIdentidade(o.id);
  const dados = o.dadosOcorrencia || {};
  const evento = o.evento || {};
  const grupos = demonstrativos(dados);
  const pgtos = pagamentos(dados);
  const { fields, counts } = informacoesRelevantes(dados);
  const envios = [...(evento.enviosEvento || [])].sort(
    (a, b) => Number(b.id) - Number(a.id)
  );
  const totalizadores = evento.eventoTotalizador || [];
  const kpis = [];
  if (grupos.length)
    kpis.push(
      { label: "Demonstrativos", value: grupos.length, icon: "receipt_long" },
      {
        label: "Rubricas declaradas",
        value: numero(grupos.reduce((s, g) => s + g.rubricas.length, 0)),
        icon: "format_list_numbered"
      }
    );
  if (pgtos.length)
    kpis.push({ label: "Pagamentos", value: pgtos.length, icon: "payments" });
  if (!kpis.length)
    Object.entries(counts)
      .slice(0, 2)
      .forEach(([label, value]) =>
        kpis.push({ label, value, icon: "format_list_numbered" })
      );
  kpis.push(
    { label: "Tentativas de envio", value: envios.length, icon: "history" },
    {
      label: "Totalizadores locais",
      value: totalizadores.length,
      icon: "calculate"
    }
  );
  const resumo = (
    <Stack spacing={3}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Campo
            label="Pessoa"
            value={
              identidade.data?.nome ||
              dados.trabalhador?.nmTrab ||
              dados.beneficiario?.nmBenefic ||
              "Nome não disponível no cadastro local"
            }
          />
          {identidade.error && (
            <Typography color="error" variant="caption">
              Não foi possível consultar o nome complementar.
            </Typography>
          )}
        </Grid>
        <Grid item xs={6} sm={3}>
          <Campo label="CPF" value={cpfExibicao(o.cpf)} />
        </Grid>
        <Grid item xs={6} sm={3}>
          <Campo
            label="Matrícula"
            value={o.matricula || identidade.data?.matricula}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <Campo
            label="Competência de apuração"
            value={competenciaExibicao(dados.ideEvento?.perApur)}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <Campo label="Operação" value={o.operacao} />
        </Grid>
        <Grid item xs={6} sm={3}>
          <Campo label="Referência na origem" value={o.referencia} />
        </Grid>
        <Grid item xs={6} sm={3}>
          <Campo
            label="Data da ocorrência"
            value={dataExibicao(o.dataOcorrencia)}
          />
        </Grid>
      </Grid>
      {fields.length > 0 ? (
        <>
          <Typography variant="h6">Informações do evento</Typography>
          <Grid container spacing={2}>
            {fields.map((f, i) => (
              <Grid item xs={12} sm={6} md={4} key={`${f.path}-${i}`}>
                <Paper
                  variant="outlined"
                  sx={{ p: 2, height: "100%", borderRadius: 2 }}
                >
                  <Campo label={f.label} value={f.value} />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <Alert severity="info">
          As informações completas estão na aba Dados técnicos.
        </Alert>
      )}
      <Button
        component={Link}
        to={`/pendencias?referencia=${encodeURIComponent(
          evento.id || ""
        )}&tipo=OCORRENCIA`}
        sx={{ alignSelf: "flex-start" }}
        disabled={!evento.id}
      >
        Consultar sincronização com a Folha
      </Button>
    </Stack>
  );
  const auditoria = (
    <Stack spacing={2}>
      <AutoriaRecebimento ocorrencia={o} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Campo
            label="Recebida no conector"
            value={dataExibicao(o.dataRecebimento)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Campo label="Recibo no eSocial" value={evento.nrRecibo} />
        </Grid>
      </Grid>
      {!envios.length ? (
        <Alert severity="info">Nenhuma tentativa de envio registrada.</Alert>
      ) : (
        <TableContainer>
          <Table size="small" aria-label="Histórico de envios">
            <TableHead>
              <TableRow>
                <TableCell>Tentativa</TableCell>
                <TableCell>Geração / envio</TableCell>
                <TableCell>Lote / protocolo</TableCell>
                <TableCell>Retorno</TableCell>
                <TableCell>Ocorrências</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {envios.map((e) => (
                <TableRow key={e.id}>
                  <TableCell>
                    #{e.id}
                    <Typography variant="caption" display="block">
                      Leiaute {e.versao || "—"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {dataExibicao(e.dtaGeracaoEvento)}
                    <Typography variant="caption" display="block">
                      Enviado: {dataExibicao(e.lote?.dtaEnvio)}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ overflowWrap: "anywhere" }}>
                    #{e.lote?.id || "—"}
                    <Typography variant="caption" display="block">
                      {e.lote?.protocolo || "Sem protocolo"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {e.codRespostaProcessamento?.desResposta ||
                      e.codRespostaProcessamento?.codResposta ||
                      "Aguardando retorno"}
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={`${e.errosProcessamento?.length || 0} mensagens`}
                    />
                    {e.erroInterno && (
                      <Typography
                        variant="caption"
                        color="error"
                        display="block"
                      >
                        Erro interno registrado
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Stack>
  );
  const secoes = [
    { id: "resumo", label: "Resumo", icon: "summarize", content: resumo }
  ];
  if (grupos.length || pgtos.length)
    secoes.push({
      id: "demonstrativos",
      label: pgtos.length ? "Pagamentos" : "Demonstrativos",
      icon: "receipt_long",
      content: <Demonstrativos dados={dados} />
    });
  secoes.push(
    {
      id: "totalizadores",
      label: `Totalizadores (${totalizadores.length})`,
      icon: "calculate",
      content: <Totalizadores items={totalizadores} />
    },
    {
      id: "auditoria",
      label: "Auditoria",
      icon: "history",
      content: auditoria
    },
    {
      id: "tecnicos",
      label: "Dados técnicos",
      icon: "code",
      content: (
        <Stack spacing={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Campo label="ID eSocial" value={evento.idEvento} />
            </Grid>
            <Grid item xs={6} md={3}>
              <Campo label="ID da ocorrência" value={o.id} />
            </Grid>
            <Grid item xs={6} md={3}>
              <Campo label="ID do evento" value={evento.id} />
            </Grid>
          </Grid>
          <JsonPanel
            primary="Dados enviados"
            secondary="Conteúdo original recebido da Folha"
            src={dados}
          />
          <JsonPanel primary="Evento e retornos" src={evento} collapsed />
        </Stack>
      )
    }
  );
  return (
    <Box>
      <Indicadores items={kpis.slice(0, 4)} />
      <Abas secoes={secoes} />
    </Box>
  );
}
